<template>
    <div class="container-fluid app-view">
        <nav class="navbar navbar-expand navbar-dark fixed-top bg-dark" v-if="isAuthenticated">
            <router-link tag="a" to="/" class="navbar-brand">
                Subscriberi SMS/Email
            </router-link>
            <button class="navbar-toggler" type="button">
                <span class="navbar-toggler-icon"></span>
            </button>
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right>
                    <!-- Using 'button-content' slot -->
                    <template slot="button-content">
                        <i class="material-icons">
                        account_circle
                        </i>
                        {{user.name}}
                    </template>
                    <b-dropdown-item to="profile">Profil</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="logout" :variant="'danger'">Log Out</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </nav>
        <router-view></router-view>
    </div>
</template>

<script>
    import * as types from './store/types'
    import { mapGetters, mapState } from 'vuex'
    export default {
        methods: {
            logout(){
                this.$store.dispatch('auth/'+types.AUTH_LOGOUT).then(() => {
                    this.$router.push('/login')
                })
            }
        },
        computed: {
            ... mapGetters('auth', ['isAuthenticated', 'hasRole']),
            ... mapState('auth', ['user'])
        }

    }
</script>

<style scoped>
.app-view{
    margin-top: 80px;
}
</style>